(() => {
  const init = () => {
    const popup = document.getElementById('halo-quick-view-popup');
    if (!popup) return;
    const close = popup.querySelector('[data-close-quick-view-popup]');
    const inerted = new Set();
    let open = false, suspended = false, opener = null, lastFocus = null;
    const visible = el => el?.isConnected && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]');
    const controls = () => [...popup.querySelectorAll('button,input,select,textarea,a[href],[tabindex]')].filter(el => !el.disabled && el.tabIndex >= 0 && visible(el));
    const focusFirst = () => (controls()[0] || popup).focus({preventScroll:true});
    const release = () => { inerted.forEach(el => { el.inert = false; }); inerted.clear(); };
    const isolate = () => {
      let current = popup;
      while (current.parentElement) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && !sibling.inert && !sibling.matches('script,style,link,.background-overlay')) {
            sibling.inert = true; inerted.add(sibling);
          }
        }
        current = current.parentElement;
        if (current === document.body) break;
      }
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-open-quick-view-popup]');
      if (trigger) opener = trigger;
    }, true);
    const sync = () => {
      const next = document.body.classList.contains('quick-view-show');
      const nested = ['modal-share-open','cart-sidebar-show','quickshop-popup-show','edit-cart-show','compare-color-show','size-chart-show','ask-an-expert-show','term-condition-show','has-warning'].some(name => document.body.classList.contains(name));
      if (next && !open) {
        open = true; suspended = nested; popup.inert = false;
        if (!nested) {
          isolate();
          let frames = 0;
          const focus = () => { if (!open || suspended) return; if (visible(close)) close.focus({preventScroll:true}); else if (++frames < 90) requestAnimationFrame(focus); };
          requestAnimationFrame(focus);
        }
      } else if (!next && open) {
        open = false; suspended = false; release(); popup.inert = true;
        if (!nested && opener?.isConnected) {
          if (!visible(opener)) opener.closest('.card')?.querySelector('a[href]')?.focus({preventScroll:true});
          if (visible(opener)) opener.focus({preventScroll:true});
        }
      } else if (open && suspended !== nested) {
        suspended = nested;
        if (nested) release();
        else requestAnimationFrame(() => {
          if (!open || suspended) return;
          popup.inert = false; isolate();
          if (visible(lastFocus)) lastFocus.focus({preventScroll:true}); else focusFirst();
        });
      }
    };
    new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});
    document.addEventListener('focusin', event => {
      if (!open || suspended) return;
      if (popup.contains(event.target)) lastFocus = event.target;
      else focusFirst();
    });
    document.addEventListener('keydown', event => {
      if (!open || suspended) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close.click(); }
      else if (event.key === 'Tab') {
        const items = controls(), first = items[0] || popup, last = items[items.length - 1] || popup;
        if (!popup.contains(document.activeElement) || event.shiftKey && document.activeElement === first || !event.shiftKey && document.activeElement === last || !items.length) {
          event.preventDefault(); (event.shiftKey ? last : first).focus();
        }
      }
    },true);
    const normalizeGallery = () => {
      const title = popup.querySelector('#lb-quick-view-title');
      if (title?.textContent.trim()) {
        if (popup.getAttribute('aria-labelledby') !== title.id) popup.setAttribute('aria-labelledby', title.id);
      } else if (popup.hasAttribute('aria-labelledby')) {
        popup.removeAttribute('aria-labelledby');
      }
      popup.querySelectorAll('.slick-cloned').forEach(el => { if (el.hasAttribute('id') && !el.id) el.removeAttribute('id'); });
      popup.querySelectorAll('img.zoomImg[alt=""][role="presentation"]').forEach(el => el.removeAttribute('role'));
    };
    new MutationObserver(normalizeGallery).observe(popup,{childList:true,subtree:true,attributes:true,attributeFilter:['id','role']});
    normalizeGallery();
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
